import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78683ed6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "custom-upload"
};
const _hoisted_2 = {
  class: "upload-btn"
};
const _hoisted_3 = {
  key: 0,
  class: "file-count"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  style: {
    "height": "1px",
    "background": "#eeeff1"
  }
};
const _hoisted_6 = {
  key: 1,
  class: "upload-file-list"
};
const _hoisted_7 = {
  key: 0
};
import { ElMessage } from 'element-plus';
import { Plus, CircleCloseFilled } from '@element-plus/icons-vue';
import { useDownload } from '@/common/hooks/useDownload';
import { useUpload } from '@/common/hooks/useUpload';
import { useUploadWidget } from '@/common/hooks/useUploadWidget';
import UploadFileList from '@/components/UploadFileList/index.vue';
import PreviewDialog from '@/components/Preview/Dialog.vue';
import { getFileType } from '@/common/utils';

import { ref, computed, nextTick, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      default: () => []
    },
    size: {
      default: 'default'
    },
    type: {
      default: 'dropdown'
    },
    itemType: {
      default: 'card'
    },
    direction: {
      default: 'vertical'
    },
    supportPreview: {
      type: Boolean,
      default: true
    },
    supportDownload: {
      type: Boolean,
      default: true
    },
    limit: {
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      default: ''
    },
    headers: {
      default: {}
    },
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      default: {}
    },
    name: {
      default: 'file'
    },
    accept: {},
    beforeUpload: {},
    beforeRemove: {},
    onExceed: {}
  },
  emits: ['update:modelValue', 'error', 'success', 'remove', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      downloadFile
    } = useDownload();
    const {
      getUploadHeaders,
      getUploadActionUrl,
      parseUploadData,
      fileListToJson
    } = useUpload();
    const props = __props;
    const showPopover = ref(false);
    const showPreview = ref(false);
    const fileIndex = ref(0);
    const uploadWidget = useUploadWidget(props.limit);
    const fileList = computed(() => {
      return (props.modelValue || []).map(item => {
        return {
          ...item,
          type: getFileType(item.name)
        };
      });
    });
    const showCardAddBtn = computed(() => {
      let temp = props.itemType === 'card' && (props.limit === 0 || props.limit == null || fileList.value.length < props.limit);
      console.log('temp', temp);
      return temp;
    });
    const emit = __emit;
    const onPreviewClick = (file, fileList) => {
      if (props.supportPreview) {
        fileIndex.value = fileList.findIndex(item => item.url === file.url);
        nextTick(() => {
          showPreview.value = true;
        });
      } else if (props.supportDownload) {
        downloadFile(file.url, file.name);
      }
    };
    const onUploadSuccess = (response, file, fileList) => {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        uploadWidget.onFileChange(file, fileList);
        console.log('uploadWidget.fileList', uploadWidget.fileList.value);
        onChange(uploadWidget.fileList.value);
        emit('success', response, file, fileList);
      } else {
        ElMessage.error(response.message);
        emit('error', response, file, fileList);
      }
    };
    const onRemoveFile = (file, fileList) => {
      if (file != null && fileList != null) {
        fileList = fileList.filter(item => item.url !== file.url);
      }
      uploadWidget.onFileChange(file, fileList);
      onChange(uploadWidget.fileList.value);
      emit('remove', file, fileList);
    };
    const onUploadError = (e, file, fileList) => {
      ElMessage.error('文件上传失败');
    };
    const onUploadLimit = (file, fileList) => {
      if (props.onExceed && typeof props.onExceed === 'function') {
        props.onExceed(file, fileList);
      } else {
        ElMessage.error('已经超出最大上传个数限制');
      }
    };
    const onDeleteFile = (file, fileList) => {
      uploadWidget.onFileChange(file, fileList);
      onChange(uploadWidget.fileList.value);
      emit('remove', file, fileList);
    };
    const uploadBtn = ref(null);
    const onAddFile = () => {
      if (uploadBtn.value) {
        uploadBtn.value.click();
      }
    };
    const onChange = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };
    watch(() => props.modelValue, val => {
      uploadWidget.fileList.value = val;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.type === 'dropdown' ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        size: _ctx.size,
        "split-button": "",
        type: "default",
        trigger: "click",
        class: _normalizeClass({
          'hide-list': _unref(fileList).length <= 0
        })
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileList), (item, index) => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: item.url
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, {
                class: "dropdown-file-item",
                type: "flex",
                justify: "space-between",
                align: "middle",
                style: {
                  "height": "36px"
                }
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  onClick: $event => onPreviewClick(item, _unref(fileList)),
                  style: {
                    "flex-grow": "1"
                  }
                }, _toDisplayString(item.name), 9, _hoisted_4), !_ctx.disabled ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  style: {
                    "margin-left": "8px"
                  },
                  onClick: _withModifiers($event => onRemoveFile(item, _unref(uploadWidget).fileList.value), ["stop"])
                }, {
                  default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                _: 2
              }, 1024), index !== _unref(fileList).length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          name: _ctx.name,
          style: {
            "width": "100%"
          },
          headers: _ctx.headers,
          action: _ctx.action,
          data: _ctx.data,
          limit: _ctx.limit,
          disabled: _ctx.disabled,
          multiple: _ctx.multiple,
          accept: _ctx.accept,
          "show-file-list": false,
          "file-list": _unref(fileList),
          "before-upload": _ctx.beforeUpload,
          "before-remove": _ctx.beforeRemove,
          "on-exceed": onUploadLimit,
          "on-success": onUploadSuccess,
          "on-remove": onRemoveFile,
          "on-error": onUploadError
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            type: "flex",
            align: "middle"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createTextVNode(" 上传文件 "), _unref(uploadWidget).fileList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(fileList).length), 1)) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }, 8, ["name", "headers", "action", "data", "limit", "disabled", "multiple", "accept", "file-list", "before-upload", "before-remove"])]),
        _: 1
      }, 8, ["size", "class"])) : _ctx.type === 'expand' ? (_openBlock(), _createBlock(_component_el_upload, {
        key: 1,
        class: _normalizeClass(["expand-upload", _ctx.itemType]),
        name: _ctx.name,
        style: {
          "width": "100%"
        },
        headers: _ctx.headers,
        action: _ctx.action,
        data: _ctx.data,
        limit: _ctx.limit,
        disabled: _ctx.disabled || _unref(fileList).length >= _ctx.limit,
        multiple: _ctx.multiple,
        accept: _ctx.accept,
        "show-file-list": false,
        "file-list": _unref(fileList),
        "before-upload": _ctx.beforeUpload,
        "before-remove": _ctx.beforeRemove,
        "on-exceed": onUploadLimit,
        "on-success": onUploadSuccess,
        "on-remove": onRemoveFile,
        "on-error": onUploadError
      }, {
        default: _withCtx(() => [_ctx.itemType === 'card' ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          type: "flex",
          style: {
            "flex-wrap": "wrap"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            ref_key: "uploadBtn",
            ref: uploadBtn,
            style: {
              "width": "0px",
              "height": "0px",
              "border": "none"
            }
          }, null, 512)]),
          _: 1
        })) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
          size: _ctx.size,
          disabled: _ctx.disabled || _unref(fileList).length >= _ctx.limit,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode(" 点击上传 ")]),
          _: 1
        }, 8, ["size", "disabled"])]))]),
        _: 1
      }, 8, ["class", "name", "headers", "action", "data", "limit", "disabled", "multiple", "accept", "file-list", "before-upload", "before-remove"])) : _createCommentVNode("", true), _ctx.type === 'expand' && _ctx.itemType === 'card' ? (_openBlock(), _createBlock(_component_el_row, {
        key: 2,
        type: "flex",
        style: {
          "flex-wrap": "wrap"
        }
      }, {
        default: _withCtx(() => [_createVNode(UploadFileList, {
          supportPreview: _ctx.supportPreview,
          supportDownload: _ctx.supportDownload,
          "file-list": _unref(fileList),
          type: _ctx.itemType,
          direction: _ctx.direction,
          supportAdd: _unref(showCardAddBtn),
          onRemove: onDeleteFile,
          onAdd: onAddFile,
          readonly: _ctx.disabled
        }, {
          default: _withCtx(() => [_unref(showCardAddBtn) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_icon, {
            style: {
              "font-size": "18px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["supportPreview", "supportDownload", "file-list", "type", "direction", "supportAdd", "readonly"])]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.type === 'expand' && _ctx.itemType === 'text' ? (_openBlock(), _createBlock(UploadFileList, {
        key: 3,
        supportPreview: _ctx.supportPreview,
        supportDownload: _ctx.supportDownload,
        "file-list": _unref(fileList),
        type: _ctx.itemType,
        direction: _ctx.direction,
        style: {
          "margin-top": "8px"
        },
        onRemove: onDeleteFile
      }, null, 8, ["supportPreview", "supportDownload", "file-list", "type", "direction"])) : _createCommentVNode("", true), _unref(showPreview) ? (_openBlock(), _createBlock(PreviewDialog, {
        key: 4,
        visible: _unref(showPreview),
        "file-list": _unref(fileList),
        defaultIndex: _unref(fileIndex),
        readonly: !_ctx.supportDownload,
        onClose: _cache[0] || (_cache[0] = $event => showPreview.value = false)
      }, null, 8, ["visible", "file-list", "defaultIndex", "readonly"])) : _createCommentVNode("", true)]);
    };
  }
});